import React from "react";
import { Navigate } from "react-router-dom";

const ConversationsPage = () => {
  // The user-facing collection is thread-first. Preserve the legacy URL for
  // bookmarks, but never render the obsolete top-level conversation table.
  return <Navigate to="/" replace />;
};

export default ConversationsPage;
